import type {
  CategoryModel,
  CategoryViewModel,
  CreateCategoryPayload,
  UpdateCategoryPayload,
} from "@models/category";

// ============================================================================
// Response Builders (snake_case to camelCase)
// ============================================================================

export const buildCategoryViewModel = (
  response: CategoryModel,
): CategoryViewModel => ({
  id: response.id,
  code: response.code,
  name: response.name,
  description: response.description,
  createdAt: response.created_at ? new Date(response.created_at) : null,
  updatedAt: response.updated_at ? new Date(response.updated_at) : null,
});

export const buildCategoryViewModels = (
  responses: CategoryModel[],
): CategoryViewModel[] => responses.map(buildCategoryViewModel);

// ============================================================================
// Request Builders (camelCase to snake_case)
// ============================================================================

export const buildCreateCategoryRequest = (data: CreateCategoryPayload) => ({
  code: data.code,
  name: data.name,
  description: data.description || null,
});

export const buildUpdateCategoryRequest = (data: UpdateCategoryPayload) => {
  const request: Record<string, unknown> = {};
  if (data.code !== undefined) request.code = data.code;
  if (data.name !== undefined) request.name = data.name;
  if (data.description !== undefined) request.description = data.description;
  return request;
};
